<script setup>
import {computed} from 'vue'
import {useCollectionFiltersStore} from '@/stores/collectionFilters'
import CollectionFilter from "@/common/collection-filter/CollectionFilter.vue"
import Button from '@/common/Button.vue'

const props = defineProps({
    formId: String,
    currentData: Object,
    field: Object,
})

const collectionFiltersStore = useCollectionFiltersStore()

// Computed properties
const contentId = computed(() => {
    return props.currentData?.id
})

const items = computed(() => {
    return collectionFiltersStore.data[contentId.value]
})

// Methods
const addFilter = () => {
    collectionFiltersStore.addFilter({
        contentId: contentId.value
    })
}

const init = () => {
    collectionFiltersStore.init({
        contentId: contentId.value,
        refresh: true
    })
}

// Emulating the created hook logic
init()
</script>

<template>
    <form @submit.prevent>
        <div v-if="items" class="mb-2 list-group">
            <div class="list-group-item px-2" v-for="item in items" :key="item.id">
                <CollectionFilter :content-id="contentId" :item="item"/>
            </div>
        </div>

        <Button @click="addFilter" class="border"><i class="bi-plus-lg"></i></Button>
    </form>
</template>